import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 0 5px 0; 
  
  width: 58px;
  height: 500px;
  left: 0px;
  top: 0px;

  background: ${props => props.theme.asideColor}
`;
